import { RequestQueryBuilder } from "@nestjsx/crud-request";
import { applicationApi } from "../../common/api";
import { CreateTag, Tags } from "./types";

// Define a service using a base URL and expected endpoints
export const tagApi = applicationApi.injectEndpoints({
  endpoints: (builder) => ({
    getTagByType: builder.query<Tags[], string>({
      query: (type) =>
        "tags?" +
        RequestQueryBuilder.create()
          .setFilter({
            field: "type",
            operator: "$eq",
            value: type,
          })
          .query(),
      providesTags: [{ type: "Tags", id: "LIST" }],
    }),
    createNewTag: builder.mutation<Tags, CreateTag>({
      query: (body) => ({
        url: "/tags",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Tags", id: "LIST" }],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetTagByTypeQuery, useCreateNewTagMutation } = tagApi;
